import React from 'react';
import Microlink from "@microlink/react";
import {Label} from "../index";

/**
 * Create a preview-link component.
 *
 * @example
 * <UrlPreview
 *      url={'https://dribbble.com/'}
 *      label={"URL Preview"}
 *      wrapperClassName={''}
 *      labelClassName={'text-nowrap fw-semi-bold'}
 *      // className={''}
 *      // style={{}}
 *      wrapperStyle={{}}
 *      labelStyle={{}}
 * />
 */
const UrlPreview = React.memo(({
                                   url,
                                   label,
                                   wrapperClassName = '',
                                   className = '',
                                   labelClassName = '',
                                   style = {},
                                   labelStyle = {},
                                   wrapperStyle = {},
                               }) => {
    return (
        <div className={`${wrapperClassName}`} style={wrapperStyle}>
            <Label className={`m-0 p-0 pb-1x ${labelClassName}`} style={labelStyle}>{label}:&nbsp;</Label>
            <Microlink
                url={url}
                className={className}
                style={style}/>
        </div>
    );
});

export default UrlPreview;
